<script lang="ts">
import { defineComponent, PropType, inject, watch } from 'vue'
import SelectorForm from '@/components/form/SelectorForm.vue'

export default defineComponent({
  name: 'SelectorProfession',

  components: {
    SelectorForm,
  },

  props: {
    profession: {
      type: Object as PropType<InputText>,
      required: true,
    },

    namespace: {
      type: String,
      default: '',
    },

    defaultSelectorLabel: {
      type: String,
      default: '選択してください',
    },

    defaultSelectorValue: {
      type: String,
      default: '',
    },

    header: {
      type: String,
      default: '職種',
    },
  },

  emits: [
    'update:profession',
  ],

  setup(props, { emit }) {
    const PROFESSIONS = inject<string[]>('PROFESSIONS')!

    // 選択肢に存在しない値の場合は空の値で再設定
    // ※ 古いユーザの場合、古い区分で値を保持している場合があり、その場合は強制的に再設定させる。
    watch(() => props.profession.value, () => {
      if (props.profession.value && !PROFESSIONS.includes(props.profession.value)) {
        emit('update:profession', '')
      }
    })

    const emitValue = (value: string) => {
      if (typeof value === 'string') {
        emit('update:profession', value)
      } else {
        emit('update:profession', '')
      }
    }

    return {
      // constants
      PROFESSIONS,

      // methods
      emitValue,
    }
  }
})
</script>

<template>
  <SelectorForm
    :model-value="profession.value"
    :items="PROFESSIONS"
    :default-selector-label="defaultSelectorLabel"
    :default-selector-value="defaultSelectorValue"
    :namespace="namespace"
    :name="profession.name"
    :header="header"
    :validation-scheme="profession.validationScheme"
    @update:model-value="emitValue($event)" />
</template>
